export const keyClientList = [
  'Auto & General - Budget Direct',
  'Auto & General - Qantas',
  'Auto & General - First for Women',
  'Auto & General - Ing',
  'Auto & General - Coles',
  'Auto & General - Virgin',
];

export const accomodationRequirementList = [
  'Short Term',
  'Long Term',
  'Emergency',
];

export const claimTypesList = [
  'Accidental Damage or Loss',
  'Breakage of Glass',
  'Bush Fire',
  'Earth Movement',
  'Earthquake',
  'Escape of Liquid',
  'Explosion',
  'Fire',
  'Flood',
  'Hail',
  'Impact',
  'Lightning',
  'Malicious Damage',
  'Motor Burnout',
  'Rain',
  'Theft or Attempted Theft',
  'Wind',
];
